import { create } from "zustand";
import { Product } from "../types/product";
import productsData from "../demo/products.json"; // Assuming your JSON is here
import { executeFetch } from "../helper/Api";
import { Category } from "../types/Category";
import { Brands } from "../types/Brands";

interface CategoryStore {
  categories: Category[];
  brands: Brands[];
  getCategories: () => Promise<void>;
  getBrands: () => Promise<void>;
}




const useCategoryStore = create<CategoryStore>((set, get) => ({
  categories: [],
  brands: [],
  getCategories: async () => {
    try {
      const resp = await executeFetch<Category[]>(`Category/GetCategories`)
      if(resp.error){
        console.error(resp.error.message)
     }else{
      set({ categories: resp.data as Category[]});
     }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  },
  getBrands: async () => {
    try {
        const resp = await executeFetch<Brands[]>('Category/GetBrands');
        if(resp.error){
          console.error(resp.error.message)
       }else{
        set({ brands: resp.data as Brands[]});
       }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
  }
 
}));

export default useCategoryStore;